import axios from './axios'
import { Score } from '@/../../EshJSLib/models/patient'
import * as model from '@/../../EshJSLib/models/patient';


export async function saveScore(params: Score) {

    const json = JSON.stringify(params);
    const response = await axios.post(`/api/score`, json);
    return response.data;
}

export async function getFilteredTypePatientScores(id: number,name:string) {

    const response = await axios.get(`/api/score/${id}/${name}`  );
    return response.data.data as model.Score[];
}

export async function getCha2Ds2PatientScores() {

    const response = await axios.get(`/api/score/cha2ds2-score`);
    return response.data.data as model.Score[];
}

export async function getMeldPatientScores() {

    const response = await axios.get(`/api/score/meld-score`);
    return response.data as model.Score[];
}

export async function getFraminghamPatientScores() {

    const response = await axios.get(`/api/score/framingham-score`);
    return response.data as model.Score[];
}

export async function getCardiovascolarePatientScores() {

    const response = await axios.get(`/api/score/cardiovascolare-score`);
    return response.data as model.Score[];
}

export async function getAllScores(id: number) {
    const response = await axios.get(`/api/score/all/` + id );

  
    return response.data;
}